<script lang="ts">
    let size: number = 50
</script>

<div class="pad-vert">
    <div class="loader" style="width: {size}px; height: {size}px;" />
</div>
